var render = function () {
  var _vm$invoiceDetails$in;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('table', {
    staticClass: "table w-100"
  }, [_vm._m(0), _c('tbody', [_vm.billingInvoice.records.length < 1 ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No records found.")])]) : _vm._e(), _vm._l(_vm.billingInvoice.records, function (item, index) {
    return _c('tr', {
      key: index,
      class: item.invoice_details.invoice_status === 'UNPAID' ? 'unpaid' : 'paid'
    }, [_c('td', [_c('span', [_vm._v(_vm._s(item.invoice_details.invoice_id))]), _c('span', [_vm._v(_vm._s("System ID: " + item.invoice_details.invoice_policy_id))]), item.invoice_details.term_status ? _c('span', [_vm._v(" " + _vm._s(item.invoice_details.term_status) + " [ " + _vm._s(_vm._f("date_format")(item.invoice_details.term_date, "YYYY-MM-DD", "MM/DD/YYYY")) + " ] ")]) : _vm._e()]), _c('td', [_c('span', [_vm._v(_vm._s("Invoice Due Date: " + item.invoice_details.invoice_due_date))]), _c('span', [_vm._v("Service Date: " + _vm._s(item.invoice_details.invoice_start_date) + " - " + _vm._s(item.invoice_details.invoice_end_date))])]), _c('td', [item.invoice_details.efee !== '$0.00' ? _c('span', [_vm._v(_vm._s("Efees Amount: " + item.invoice_details.efee))]) : _vm._e(), item.invoice_details.late_fee !== '$0.00' ? _c('span', [_vm._v(_vm._s("Late Fee Amount: " + item.invoice_details.late_fee))]) : _vm._e(), item.invoice_details.paid_amount !== '$0.00' ? _c('span', [_vm._v(_vm._s("Paid Amount: " + item.invoice_details.paid_amount))]) : _vm._e(), item.invoice_details.overall_due_amount !== '$0.00' ? _c('span', [_c('strong', [_vm._v(_vm._s("Overall Due Amount: " + item.invoice_details.overall_due_amount))])]) : _vm._e()]), _c('td', [_c('strong', [_vm._v(_vm._s(item.invoice_details.invoice_status))])]), _c('td', [item.billing_details && item.billing_details.length > 0 ? _vm._l(item.billing_details, function (billingData, billingIndex) {
      return _c('div', {
        key: billingIndex,
        staticClass: "billing-entry"
      }, [_c('span', [_vm._v(_vm._s("Payment Date: " + billingData.payment_date))]), _c('span', [_vm._v(_vm._s("Payment Method: " + billingData.method))]), _c('span', {
        staticStyle: {
          "display": "inline-block"
        }
      }, [_vm._v(" Payment Status: "), _c('strong', [_vm._v(_vm._s(billingData.payment_status.toUpperCase()))])]), billingData.payment_amount ? _c('span', [_vm._v(" Amount: "), _c('strong', [_vm._v("$" + _vm._s(billingData.payment_amount))])]) : _vm._e(), billingData.payment_status === _vm.payment_status.dispute ? _c('span', [_vm._v(" Dispute Notes: "), _c('strong', [_vm._v(" " + _vm._s(item.invoice_details.dispute_notes) + " ")])]) : _vm._e(), billingData.payment_status == _vm.payment_status.failed ? _c('span', [_vm._v(" Payment Notes: "), _c('strong', [_vm._v(_vm._s(billingData.payment_notes))])]) : _vm._e(), _c('div', {
        staticClass: "action-icons"
      }, [!item.invoice_details.pay_now && _vm.shouldShowRefundButton(item) && billingData.payment_status.toUpperCase() != 'REFUNDED' && billingData.payment_status.toUpperCase() != 'DISPUTE' && billingData.payment_status.toUpperCase() != 'FAILED' && billingData.payment_status.toUpperCase() != 'REFUND-PROCESSING' ? _c('custom-button', {
        attrs: {
          "title": "Refund",
          "iconClass": "fa-solid refund-icon fa-money-bill-transfer"
        },
        on: {
          "onClicked": function onClicked($event) {
            return _vm.openModal(item, billingData, 'invoiceRefundModal');
          }
        }
      }) : _vm._e()], 1)]);
    }) : [_vm._m(1, true)]], 2)]);
  }), _c('invoice-refund-modal', {
    attrs: {
      "row": _vm.invoiceDetails.invoice_details,
      "billingDetails": _vm.billingDetails,
      "refundedAmount": _vm.getRefundedAmount((_vm$invoiceDetails$in = _vm.invoiceDetails.invoice_details) === null || _vm$invoiceDetails$in === void 0 ? void 0 : _vm$invoiceDetails$in.invoice_id)
    },
    on: {
      "refundedAmount": _vm.handleRefund
    }
  })], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _c('th', [_vm._v("Date/Term")]), _c('th', [_vm._v("Totals")]), _c('th', [_vm._v("Invoice Status")]), _c('th', [_vm._v("Payments")]), _c('th', [_vm._v("Action")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', [_vm._v("Payment Status: "), _c('strong', [_vm._v("UNPAID")])])]);
}]

export { render, staticRenderFns }